import type { ComponentProps } from 'react';

import { Image } from '@change-corgi/design-system/components/media';
import { Box } from '@change-corgi/design-system/layout';

import { usePetitionMedia } from './hooks/usePetitionMedia';

export function PetitionMedia(props: ComponentProps<typeof Box>) {
	const {
		data: { photo },
	} = usePetitionMedia();

	if (!photo) {
		return (
			<Box {...props}>
				<Image
					fetchPriority="high"
					aspectRatio="2.35"
					fit="cover"
					width="100%"
					src="https://static.change.org/images/default-petition-darker.gif"
					alt=""
					sx={{
						// removes an unwanted padding under the image
						verticalAlign: 'top',
					}}
					data-qa="hero-image"
				/>
			</Box>
		);
	}

	return (
		<Box {...props}>
			<Image
				fetchPriority="high"
				aspectRatio="2.35"
				fit="cover"
				width="100%"
				src={[photo.mobileUrl, photo.url]}
				alt=""
				sx={{
					// removes an unwanted padding under the image
					verticalAlign: 'top',
				}}
			/>
		</Box>
	);
}
